import React, { Component } from "react";
import { Button, Card, CardBody, Col, Container, Label, Row } from "reactstrap";
import { Link } from "react-router-dom";

import { Field, Form } from "formik";
//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";
import { withTranslation } from "react-i18next";

class DataEntryViewStockInword extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    //meta title
    
    document.title = "data entry person";
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem={`${this.props.t("MANAGE STOCK - INWARD")}`} />
            <Row>
              <Col xl="12">
                <Card>
                  <CardBody>
                    <div className="d-lg-flex d-block justify-content-between">
                      <div>
                        <h4 className="pb-3 text-black fw-bold">
                          View Stock (Inward)
                        </h4>
                      </div>
                      {/* <div>
                        <label
                          htmlFor="date"
                          className="pe-2 fs-5 fw-bold text-black"
                        >
                          Date:
                        </label>
                        <input
                          type="date"
                          className="fs-5 border-0 text-black"
                        />
                      </div> */}
                    </div>

                    <form>
                      <div className="mb-3 row">
                        <label
                          htmlFor="example-text-input"
                          className="col-lg-2 col-12 col-form-label"
                        >
                          <h5 className="text-secondary fw-bold"> {this.props.t('Stock ID')} </h5>
                        </label>
                        <div className="col-lg-7 col-12">
                          <input
                            className="form-control fs-5"
                            type="text"
                            name="stockID"
                            placeholder="JANGAD0000123"
                            disabled
                          />
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label
                          htmlFor="example-text-input"
                          className="col-lg-2 col-12 col-form-label"
                        >
                          <h5 className="text-secondary fw-bold">
                            
                            {this.props.t('Party Code')}
                          </h5>
                        </label>
                        <div className="col-lg-7 col-12">
                          <input
                            className="form-control fs-5"
                            type="text"
                            name="partyCode"
                            placeholder="XYZ Diamond"
                            disabled
                          />
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="col-lg-2 col-12 col-form-label">
                          <h5 className="text-secondary fw-bold">{this.props.t('Unit Name')}</h5>
                        </label>
                        <div className="col-lg-7 col-12">
                          <select
                            className="form-select fs-5 text-secondary"
                            name="unitName"
                            disabled
                          >
                            <option value="" disabled>
                              select
                            </option>
                            <option value="xyz">ABC Diamond Unit</option>
                            <option value="xyz">ABC Diamond Unit</option>
                            <option value="xyz">ABC Diamond Unit</option>
                            <option value="xyz">ABC Diamond Unit</option>
                          </select>
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label
                          htmlFor="example-text-input"
                          className="col-lg-2 col-12 col-form-label"
                        >
                          <h5 className="text-secondary fw-bold">
                            
                            {this.props.t("Total Weight")}
                          </h5>
                        </label>
                        <div className="col-lg-7 col-12">
                          <input
                            className="form-control fs-5"
                            type="text"
                            name="weight"
                            placeholder="20.25 CT"
                            disabled
                          />
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label
                          htmlFor="example-text-input"
                          className="col-lg-2 col-12 col-form-label"
                        >
                          <h5 className="text-secondary fw-bold">
                            
                            {this.props.t('Total No of Pieces')}
                          </h5>
                        </label>
                        <div className="col-lg-7 col-12">
                          <input
                            className="form-control fs-5"
                            type="text"
                            name="pieces"
                            placeholder="01%"
                            disabled
                          />
                        </div>
                      </div>

                      <div className="mb-3 row">
                        <label className="col-lg-2 col-12 col-form-label">
                          <h5 className="text-secondary fw-bold">                            
                          {this.props.t("Grader Name")}
                          </h5>
                        </label>
                        <div className="col-lg-7 col-12">
                          <select
                            className="form-select fs-5 text-secondary"
                            name="deliveryName"
                            disabled
                          >
                            <option value="" disabled>
                              select
                            </option>
                            <option value="grader1">Grader 1</option>
                            <option value="grader2">Grader 1</option>
                            <option value="grader3">Grader 1</option>
                            <option value="grader4">Grader 1</option>
                          </select>
                        </div>
                      </div>

                      <div className="mb-3 row">
                        <label
                          htmlFor="example-text-input"
                          className="col-lg-2 col-12 col-form-label"
                        >
                          <h5 className="text-secondary fw-bold">                            
                          Self Internal Remarks
                          </h5>
                        </label>
                        <div className="col-lg-10 col-12">
                          <textarea className="form-control fs-5"
                            type="text"
                            name="notes"
                            disabled
                            rows="5" >                    
                            
                            </textarea>
                        </div>                  
                      </div>
                      <div className="col-md-12 text-end">
                      <Link to="/data-entry-office-stock-list">  <Button
                          color="primary"
                          className="fs-4 px-5"
                          type="Back"
                        >
                          Back
                        </Button></Link> 
                        <Button onClick={e => window.print(e.preventDefault())} color="success"
                          className="fs-4 ms-2"
                          type="submit">
                          <img src="images/dashboard-images/printwhite.svg" alt="print" />
                        </Button>
                      </div>
                    </form>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(DataEntryViewStockInword);
